import createSelector from 'lib/web/createSelector'
import { checkCanViewLuxPlusBenefits, isLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getAvailableAccommodationBenefits } from 'luxPlus/selectors/benefits/accommodation'
import { isCustomerSupportMode } from 'selectors/featuresSelectors'

export const shouldLowSavingsExperimentBeEnabled = createSelector(
  isLuxPlusEnabled,
  checkCanViewLuxPlusBenefits,
  getAvailableAccommodationBenefits,
  isCustomerSupportMode,
  (state: App.State) => state.config.headlessMode,
  (state: App.State) => state.checkout.cart.isGift,
  (lusPlusEnabled, canViewLuxPlusBenefits, accomBenefits, customerSupportMode, headlessMode, isGift): boolean => {
    const totalSavings = accomBenefits.totalMemberPriceSavings ?? 0

    return !!(lusPlusEnabled &&
      !canViewLuxPlusBenefits &&
      totalSavings > 0 &&
      totalSavings <= 100 &&
      !accomBenefits.membershipRequired &&
      !accomBenefits.isTourWithMemberPrice &&
      !customerSupportMode &&
      !headlessMode &&
      !isGift)
  },
)
